import * as React from 'react';
import {FormattedMessage} from "react-intl";
import {P} from "@atoms/Text/P";
import {ObjectStatus, StageStatus} from "features/search/filters/enums";
import {useAuth} from "features/authentication/hooks/useAuth";
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

interface Props {
    stageName: string;
    customFormText?: string;
    objectStatus?: string;
    stageStatus: string;

}

export const InterestFormHeader: React.FunctionComponent<Props> = ({stageName, customFormText, objectStatus, stageStatus}) => {
    const {isLoggedIn} = useAuth();

    const isObjectAndReserved = () => objectStatus && objectStatus === ObjectStatus.RESERVED;

    const getStageMessage = () => {
        if (isObjectAndReserved()) {
            return <FormattedMessage id="jm.components.InterestForm.infoReserved" />;
        }

        const notLoggedInMessages = {
            [StageStatus.PLANNED]: "jm.components.InterestForm.infoPlannedNotLoggedIn",
            [StageStatus.VIP]: "jm.components.InterestForm.infoPlannedNotLoggedIn",
            [StageStatus.FORSALE]: "jm.components.InterestForm.infoForSaleNotLoggedIn",
            [StageStatus.PRESELLING]: "jm.components.InterestForm.infoForSaleNotLoggedIn",
            [StageStatus.MOVE_IN_READY]: "jm.components.InterestForm.infoForSaleNotLoggedIn",
        };

        const loggedInMessages = {
            [StageStatus.PLANNED]: "jm.components.InterestForm.infoPlannedLoggedIn",
            [StageStatus.VIP]: "jm.components.InterestForm.infoPlannedLoggedIn",
            [StageStatus.FORSALE]: "jm.components.InterestForm.infoForSaleLoggedIn",
            [StageStatus.PRESELLING]: "jm.components.InterestForm.infoForSaleLoggedIn",
            [StageStatus.MOVE_IN_READY]: "jm.components.InterestForm.infoForSaleLoggedIn",
        };

        if (!isLoggedIn) {
            return notLoggedInMessages[stageStatus] ? <FormattedMessage id={notLoggedInMessages[stageStatus]} /> : '';
        } else {
            return loggedInMessages[stageStatus] ? <FormattedMessage id={loggedInMessages[stageStatus]} /> : '';
        }
    };

    return (
        <>
            <Headline level={HeadlineLevel.H2} center>
                <FormattedMessage id="jm.components.InterestForm.header" />{stageName && <br />}
                {stageName}
            </Headline>

            {customFormText &&
                <P>
                    {customFormText}
                </P>
            }

            <P>
                {getStageMessage()}
            </P>

            {!isLoggedIn &&
                <P>
                    <FormattedMessage id="jm.components.InterestForm.notLoggedIn" />
                </P>
            }
        </>
    )
};
